<template>
  <!--eslint-disable-->
  <v-container class="pa-0">
    <v-card flat class="pa-0">
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="settingsFormData.minor_settings.ibl_link"
          :single-select="singleSelect"
          show-select
          dense
          item-key="link"
          v-model="settingsFormData.minor_settings.selected_ibl_links"
        >
          <template v-slot:top>
            <div class="d-flex">
              <v-spacer />
              <v-btn color="primary" small @click="addNewLine">
                <v-icon class="mr-1" size="12">mdi-plus</v-icon>
                new link
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.title`]="{ item, index }">
            <v-text-field v-model="item.title" v-if="isEdit === index">
            </v-text-field>
            <span v-else>{{ item.title }}</span>
          </template>
          <template v-slot:[`item.link`]="{ item, index }">
            <v-text-field
              v-model="item.link"
              v-if="isEdit === index"
            ></v-text-field>
            <a v-else :href="item.link" target="_blank">{{ item.link }}</a>
          </template>
          <template v-slot:[`item.actions`]="{ item, index }">
            <div class="d-flex">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-on="on"
                    v-bind="attrs"
                    @click="isEdit === index ? save() : editItem(index)"
                    class="mr-2"
                    :color="isEdit === index ? 'primary' : 'info'"
                  >
                    {{ `${isEdit === index ? "done" : "edit"}` }}
                  </v-icon>
                </template>
                <span>{{ `${isEdit === index ? "done" : "edit"}` }}</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
/*eslint-disable*/
// import { helper } from "@/packages/dashboard/utils";
export default {
  name: "iblLinks",
  props: {
    editingIndex: { type: Number, default: -1 },
    settingsFormData: Object,
    saveSettings: Function,
  },
  data() {
    return {
      singleSelect: false,
      defaultLineItem: {
        link: "",
        title: "",
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Administrator/getSettings");
    });
  },
  computed: {
    settings() {
      return this.$store.getters["Administrator/administratorGetters"](
        "settings",
      );
    },
    headers() {
      return [
        { text: "Name", value: "title", align: "start" },
        { text: "Links", value: "link", align: "start" },
        { text: "", value: "actions", align: "start" },
      ];
    },
    isEdit: {
      get() {
        return this.editingIndex;
      },
      set(val) {
        this.editingIndex = val;
        // this.$emit("update:editingIndex", val);
      },
    },
  },
  methods: {
    addNewLine() {
      this.settingsFormData.minor_settings.ibl_link.unshift({
        ...this.defaultLineItem,
      });
      this.settingsFormData.minor_settings.ibl_link.forEach(
        function (item, index) {
          item.id = index;
        },
      );
      this.editItem(0);
    },
    editItem(i) {
      console.log(this.isEdit === i);
      this.isEdit === i ? (this.isEdit = -1) : (this.isEdit = i);
      console.log(this.isEdit, i);
    },
    save() {
      this.isEdit = -1;
      this.saveSettings();
    },
  },
  watch: {
    settings: {
      handler: async function (val) {
        if (val) {
          this.settingsFormData.minor_settings =
            val && val.minor_settings
              ? JSON.parse(val.minor_settings)
              : this.settingsFormData.minor_settings;
          this.settingsFormData.site_colors =
            val && val.site_colors
              ? JSON.parse(val.site_colors)
              : this.objectToArray(this.$vuetify.theme.themes.light);
          this.settingsFormData.site_installed_packages =
            val && val.site_installed_packages
              ? JSON.parse(val.site_installed_packages)
              : [];
        }
      },
      deep: true,
    },
  },
};
</script>
